export default {
    firstToCreate: 'इस फोरम में थ्रेड बनाने वाले पहले व्यक्ति बनें',
    firstToPostInCategory: 'इस श्रेणी में पोस्ट करने वाले पहले व्यक्ति बनें',
    firstToRespondToTopic: 'इस विषय पर प्रतिक्रिया देने वाले पहले व्यक्ति बनें!',
    createNewThread: 'नया थ्रेड बनाएं',
    thread: 'थ्रेड',
    viewThread: 'थ्रेड देखें',
    replies: 'प्रतिक्रियाएँ',
    noReplies: 'कोई प्रतिक्रिया नहीं',
    reply: 'प्रतिक्रिया',
    _reply: 'प्रतिक्रिया दें',
    ReplyTo: 'को उत्तर दें',
    replyToThisQuestion: 'इस प्रश्न का उत्तर दें',
    onceRepliedModeratorMayRespond: 'एक बार जब आपने उत्तर दे दिया, तो फोरम मॉडरेटर आपकी प्रतिक्रिया पर उत्तर दे सकता है',
    onceRepliedCanViewResponses: 'एक बार जब आपने उत्तर दे दिया, तो आप अन्य प्रतिभागियों की प्रतिक्रियाएँ देख सकते हैं',
    loadingResponses: 'प्रतिक्रियाएँ लोड हो रही हैं',
    hideXReplies: '{count} प्रतिक्रियाएँ छिपाएँ',
    showXReplies: '{count} प्रतिक्रियाएँ दिखाएँ',
    hideMostRecentReplies: 'सबसे हाल की प्रतिक्रियाएँ छिपाएँ',
    showMostRecentReplies: 'सबसे हाल की प्रतिक्रियाएँ दिखाएँ',
    post: 'पोस्ट',
    message: 'संदेश',
    typeMessage: 'संदेश टाइप करें',
    addPost: 'पोस्ट जोड़ें',
    addMessage: 'संदेश जोड़ें',
    editPost: 'पोस्ट संपादित करें',
    editPostWithMedia: 'मीडिया के साथ पोस्ट संपादित करें',
    createPostWithMedia: 'मीडिया के साथ पोस्ट बनाएं',
    deleteMessage: 'संदेश हटाएं',
    deleteMessageConfirm: 'क्या आप वाकई इस संदेश को हटाना चाहते हैं',
    pinPost: 'पोस्ट पिन करें',
    media: 'मीडिया',
    uploadMedia: 'मीडिया अपलोड करें',
    categories: 'श्रेणियाँ',
    goBack: 'वापस जाएं',
    goBackPrevious: 'पिछले पृष्ठ पर वापस जाएं',
    goBackToCategory: '{name} श्रेणी में वापस जाएं',
    loadingLatestThreads: 'नवीनतम थ्रेड लोड हो रहे हैं',
    loadingDiscussionForum: 'चर्चा फोरम लोड हो रहा है',
    dontShowAgainForTask: `इस कार्य के लिए दोबारा न दिखाएं`,
    title: 'शीर्षक',
    beTheFirst: 'इस थ्रेड का उत्तर देने वाले पहले व्यक्ति बनें'
};
